import type { FaireProductEntity } from "../../entity_types/product";

export const p_xncq4d9gkn: FaireProductEntity = {
  token: "p_xncq4d9gkn",
  type: "product",
  name: "4.50 Inch Black Mantra Bowl - Buddha Carving",
  brandToken: "b_v58tcqg42w",
  brandName: "Now N Zen",
  imageUrl: "https://cdn.faire.com/fastly/eff6d79ef410f1a7be2b445c5c480bc84b12e0ad9e42b6dbe47e50840c1b3698.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.94,
  description: "From the house of Now N Zen, we bring you our 4.50 Inch Black Mantra Bowl with a beautiful Buddha Carving. Impeccably crafted, this bowl serves as an essential meditation tool. Rooted in the ancient traditions of Nepal, our bowls are known for their calming and restorative properties. Whether you're a seasoned practitioner or just beginning your mindfulness journey, our Mantra Bowl is designed to enhance your meditation practice, guiding you towards tranquility and balance. Embrace peace in the present moment with Now N Zen.",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:54.914Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
